var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.616,
    height: 21.839,
    viewBox: "0 0 28.616 21.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M28.733,23.838H3.882A1.885,1.885,0,0,1,2,21.955V2.754c0-.016,0-.032,0-.048H2a.751.751,0,0,1,.164-.424c.014-.017.027-.033.042-.048A.752.752,0,0,1,2.742,2H29.874a.75.75,0,0,1,.535.234c.015.016.029.032.042.048a.75.75,0,0,1,.164.424h0c0,.016,0,.032,0,.048v19.2a1.885,1.885,0,0,1-1.883,1.883M4.689,22.332H27.927L18.772,13.94l-1.955,1.793a.753.753,0,0,1-1.018,0L13.844,13.94ZM3.506,4.464V21.373l9.223-8.455Zm16.381,8.454,9.223,8.454V4.464Zm-5.525-.547,1.946,1.784,1.944-1.782.024-.022,9.651-8.846H4.689l9.653,8.848.02.018",
    transform: "translate(-2 -1.999)",
    fill: "#152c40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.763262a7d7a32d7c409927eb68ea4caf.svg";
export { ForwardRef as ReactComponent };